<template>
  <div>
    <div class="backtop_wrap flexcenter" @click="gototop">
      <img src="../../assets/image/backtop.png" />
    </div>
  </div>
</template>

<script>
  export default {
    methods:{
      gototop(){
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
      }
    }
  }
</script>

<style scoped lang="less">
  .backtop_wrap{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #FFFFFF;
    box-shadow: 0 6px 12px 0 rgba(208, 208, 208, 0.3);
    position: fixed;
    right: 30px;
    bottom: 20%;
    z-index: 3;
    img{
      width: 20px;
      height: 20px;
    }
  }
</style>
